import { FieldType } from 'src/Common/Filters/interfaces/FiltersView';

export const MEAFilterConfig = [
  {
    fieldId: 'ID',
    fieldName: 'ID',
    fieldType: FieldType.TextField,
    internalName: 'raidid',
    responseFormat: 'number',
  },
  {
    fieldId: 'Title',
    fieldName: 'Title',
    fieldType: FieldType.TextField,
    internalName: 'fields/title',
    responseFormat: 'string',
  },
  {
    fieldId: 'ActionOwner',
    fieldName: 'Action Owner',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/assignedto/uniquename',
    responseFormat: 'string',
  },
  {
    fieldId: 'State',
    fieldName: 'State',
    fieldType: FieldType.Dropdown,
    fieldDropdownName: 'workItemStates',
    keyName: 'Name',
    internalName: 'fields/state',
    responseFormat: 'string',
  },
  {
    fieldId: 'Account',
    fieldName: 'Account',
    fieldType: FieldType.TextField,
    internalName: 'fields/account',
    responseFormat: 'string',
  },
  {
    fieldId: 'TPID',
    fieldName: 'TPID',
    fieldType: FieldType.TextField,
    internalName: 'fields/tpid',
    responseFormat: 'string',
  },
  {
    fieldId: 'Areas',
    fieldName: 'Area(s)',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'areas',
    keyName: 'area',
    internalName: 'fields/areafield',
    responseFormat: 'string',
  },
  {
    fieldId: 'Industry',
    fieldName: 'Industry',
    fieldType: FieldType.TextField,
    internalName: 'fields/industry',
    responseFormat: 'string',
  },
  {
    fieldId: 'Segment',
    fieldName: 'Segment',
    fieldType: FieldType.TextField,
    internalName: 'fields/segment',
    responseFormat: 'string',
  },
  {
    fieldId: 'EOU',
    fieldName: 'EOU',
    fieldType: FieldType.TextField,
    internalName: 'fields/eou',
    responseFormat: 'string',
  },
  {
    fieldId: 'IsBedrockCustomer',
    fieldName: 'Bedrock Customer',
    fieldType: FieldType.Dropdown,
    fieldDropdownName: 'yesNo',
    keyName: 'Name',
    internalName: 'fields/meaisbedroccustomer',
    responseFormat: 'string',
  },
  {
    fieldId: 'Requestor',
    fieldName: 'Requestor',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/requestorsinfo/uniquename',
    responseFormat: 'arrayOfObjects',
  },
  {
    fieldId: 'RequestedDate',
    fieldName: 'Requested Date',
    fieldType: FieldType.DatePicker,
    internalName: 'fields/requesteddate',
    responseFormat: 'date',
  },
];
